import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import CarImage from '@public/assets/images/car-image.png';
import useCustomAvatarStyles from './useCustomAvatarStyles';
const CustomAvatar = ({ imgSrc, initials }) => {
    const { avatarOutterContainerStyles, avatarContentContainerStyles, profileImageStyles } = useCustomAvatarStyles();
    return (_jsx(Box, { className: 'avatar-outter-container', sx: avatarOutterContainerStyles, children: _jsx(Box, { className: 'avatar-outter-container', sx: avatarContentContainerStyles, children: imgSrc ? (_jsx("img", { src: CarImage, alt: 'user-profile', style: profileImageStyles })) : (_jsx(Typography, { variant: 'subtitle2', color: 'textDisabled', children: initials })) }) }));
};
export default CustomAvatar;
